import { History } from 'history';
import { fixPathAfterFiltersChange } from './Simulation/FixPathAfterFiltersChangeAction';
import { getAlphaSettings, getLanguageFields, setTabActive } from './EditorActions/EditorActions';

// extracted to separate file to avoid circular imports
export function setActiveEditorTab(tabIndex: number, history: History<unknown>) {
  return async (dispatch: any, getState: any): Promise<object> => {
    dispatch(setTabActive(tabIndex));
    const state = getState();

    dispatch(fixPathAfterFiltersChange(history));

    const settings = getAlphaSettings(state, tabIndex).toJS();
    return dispatch(
      getLanguageFields({
        instrument: settings.instrumentType.value,
        universe: settings.universe.value,
        delay: settings.delay.value,
        region: settings.region.value,
      })
    );
  };
}
